import React from 'react';

import {useGate} from 'effector-react';
import {Route, useRouteMatch} from 'react-router-dom';

import {RouterSwitch} from 'components/ui-kit/RouterTabs';
import {Gate as ListGate} from 'models/virtualWarehouse/grid/list';
import {Gate} from 'models/virtualWarehouse/grid/table';
import {breakpoint} from 'theme';
import {useMatchMedia} from 'utils/custom-hooks';

import {VirtualWarehouseGridPage} from './Grid';
import {VirtualWarehouseGridUngroupedPage} from './GridUngrouped';

export const VirtualWarehouseWrapper = () => {
    const {path} = useRouteMatch();
    const isMobile = useMatchMedia(`(max-width: ${breakpoint.phone})`);
    useGate(isMobile ? ListGate : Gate);

    return (
        <RouterSwitch rootPath={path}>
            <Route path={`${path}`} exact>
                <VirtualWarehouseGridPage />
            </Route>
            <Route path={`${path}/ungrouped`} exact>
                <VirtualWarehouseGridUngroupedPage />
            </Route>
        </RouterSwitch>
    );
};
